import { useApi } from '@backstage/core-plugin-api';
import React, { useEffect, useRef, useState, useContext } from 'react';
import { AuthContext } from '../../../providers/AuthProvider';
import {
  DesignToCodeApi,
  designToCodeRef,
} from '../../../apis/designToCodeConfigApi';
import { FrontendConfigContext } from '../../../providers/FrontendConfigProvider';
import { EmeraldModal } from '@emerald-react/modal';
import { EmeraldProgressSpinner } from '@emerald-react/progress-indicator';
import { EmeraldBanner } from '@emerald-react/banner';
import { EmeraldButton } from '@emerald-react/button';

const DesignLintSSO = () => {
  const [uniqueId, setUniqueId] = useState<string | null>(null);
  const [userInfoStatus, setUserInfoStatus] = useState<boolean | null>(null);
  const [isUserInfoLoading, setIsUserInfoLoading] = useState(false);
  const { profEmail, profileName } = useContext(AuthContext);
  const designToCode: DesignToCodeApi = useApi(designToCodeRef);
  const { frontendConfigData } = useContext(FrontendConfigContext);

  useEffect(() => {
    if (window.location.hash) {
      setUniqueId(window.location.hash.split('#')[1]);
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search,
      );
      // console.log('DesignLint SSO 11...');
    }
  }, []);
  useEffect(() => {
    if (
      uniqueId &&
      userInfoStatus === null &&
      !isUserInfoLoading &&
      designToCode &&
      profEmail &&
      profileName &&
      frontendConfigData
    ) {
      setIsUserInfoLoading(true);
      updateUserInfo(uniqueId);
    }
    console.log('useeffect for unique id ran');
  }, [uniqueId, designToCode, profEmail, profileName, frontendConfigData]);

  const updateUserInfo = (uniqueId: string) => {
    designToCode
      .insertUserIfo(
        profEmail?.toLowerCase(),
        profileName,
        `Basic ${frontendConfigData?.figma?.token || ''}`,
        uniqueId,
      )
      .then((result: any) => {
        // console.log('User info inserted successfully: ', result);
        setUserInfoStatus(result.status === 'success');
      })
      .catch((error: any) => {
        // console.error('Error inserting user info: ', error);
        setUserInfoStatus(false);
      })
      .finally(() => {
        setIsUserInfoLoading(false);
      });
  };

  return (
    <>
      {uniqueId && (
        <EmeraldModal
          headerText="SSO Connection Status"
          opened={true}
          widthInRem={25}
          heightInRem={17.5}
        >
          {userInfoStatus === null && (
            <EmeraldProgressSpinner
              label="Establishing SSO connection..."
              determinate={false}
            />
          )}
          {userInfoStatus === true && (
            <div className="userinfo-success-message">
              <EmeraldBanner
                content="SSO connection established and user authenticated successfully."
                open
                variant="success"
              />
              <div className="userinfo-action-buttons">
                <EmeraldButton
                  label="Close"
                  onClick={() => {
                    setUniqueId(null);
                  }}
                />
              </div>
            </div>
          )}
          {userInfoStatus === false && (
            <div className="userinfo-success-message">
              <EmeraldBanner
                content="SSO connection failed. Please try again."
                open
                variant="error"
              />
              <div className="userinfo-action-buttons">
                <EmeraldButton
                  label="Close"
                  onClick={() => {
                    setUniqueId(null);
                  }}
                />
              </div>
            </div>
          )}
        </EmeraldModal>
      )}
    </>
  );
};

export default DesignLintSSO;
